module.exports = __webpack_public_path__ + "img/20200108155754360截图20200108104723612.fa16365a.jpg";